// src/lib/billing/dev-bypass.ts
//
// Single gate for the checkout-skipping Pro dev bypass (NEXT_PUBLIC_PRO_DEV_BYPASS).
//
// The bypass is a dev/preview/staging convenience — it must NEVER be one
// misconfigured env var away from running on production. So the env flag alone
// is not enough: we also require the page host to NOT be the production domain,
// checked at runtime in the browser. The check FAILS CLOSED — during SSR (no
// window) and on any production host the bypass is off, even if the env var
// leaked into the prod build.

/** Hosts where the bypass is always disabled, no matter what the env says. */
const PROD_HOSTS = new Set(['unlimitedtests.com', 'www.unlimitedtests.com'])

/**
 * Pure decision: should the dev bypass render? `hostname` is
 * window.location.hostname, or undefined during SSR (→ always false).
 * Staging (dev.unlimitedtests.com), previews (*.vercel.app), and localhost
 * keep the bypass when the flag is set.
 */
export function allowDevBypass(envFlag: string | undefined, hostname: string | undefined): boolean {
  if (envFlag !== '1') return false
  if (!hostname) return false // SSR / unknown → fail closed
  return !PROD_HOSTS.has(hostname.toLowerCase())
}

/** Convenience for client components: reads the env flag + live hostname. */
export function devBypassActive(): boolean {
  return allowDevBypass(
    process.env.NEXT_PUBLIC_PRO_DEV_BYPASS,
    typeof window !== 'undefined' ? window.location.hostname : undefined,
  )
}
